import Color from "color";

const OUTLINE = "#3eb6bc solid 0.8px";
const inputSelectedStyles = {
  root: {
    "&:hover": {
      color: "#ff560e",
    },
    "&.Mui-selected": {
      color: "#ff560e",
    },
  },
};
const darken = (color, ratio) => Color(color).darken(ratio).hex();

const FONT_FAMILY = "'TCCCUnity-Regular', 'Roboto', 'Arial', sans-serif";

const Styles = {
  MuiCssBaseline: {
    styleOverrides: `
      @font-face {
        font-family: 'TCCCUnity-Regular';
        src: url('/fonts/TCCCUnity-Regular.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
        
      }
      body {
        background-color:rgb(47, 13, 13); /* Default background color - change to red for testing */
        margin: 0;
        padding: 0;
      }
    `,
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        fontFamily: FONT_FAMILY,
      },
    },
  },
  MuiButton: {
    defaultProps: {
      disableRipple: true,
      disableFocusRipple: true,
    },
    styleOverrides: {
      textPrimary: {
        color: "#ffffff",
        backgroundColor: "#000000",
        "&:hover": {
          backgroundColor: "#ffffff",
          color: "#000000",
        },
      },
      textSecondary: {
        color: darken("#ff560e", 0.2),
        backgroundColor: "#ffffff",
        border: `1px solid ${darken("#ff560e", 0.2)}`,
        "&:hover": {
          backgroundColor: "#f2f2f2",
          color: "#000000",
          border: `1px solid #000000`,
        },
      },
      outlinedSuccess: {
        color: darken("#6ace7f", 0.5),
        backgroundColor: "#ffffff",
        border: `1px solid ${darken("#6ace7f", 0.5)}`,
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: "#000000",
        // borderBottom: `5px solid #f40000`,
        boxShadow: "none",
        "& button": {
          backgroundColor: "inherit",
          borderRadius: 0,
        },
        "& a": {
          "&:hover": {
            color: "inherit",
          },
        },
      },
    },
  },
  MuiToolbar: {
    styleOverrides: {
      root: {
        minHeight: "80px !important",
        paddingLeft: "1rem !important",
      },
    },
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        borderColor: "#d8d8d8",
      },
    },
  },
  MuiBottomNavigationAction: {
    styleOverrides: {
      root: {
        color: "#000000",
        textDecoration: "underline",
        "&:hover": {
          color: "#ff560e",
        },
      },
      label: {
        fontSize: "1rem",
      },
    },
  },
  MuiLink: {
    styleOverrides: {
      root: {
        color: "#000000",
        "&:hover": {
          color: "#ff560e",
        },
        "&:focus-visible": {
          outline: OUTLINE,
        },
      },
    },
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
      disableTouchRipple: true,
    },
    styleOverrides: {
      root: {
        "&:focus-visible": {
          outline: OUTLINE,
        },
        "&.MuiFab-success": {
          "&:hover": {
            color: "#f2f2f2",
          },
        },
        "&.MuiIconButton-root": {
          color: "#000000",
        },
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        "&.MuiListItemButton-root > *": {
          color: "#000000",
        },
        "&.Mui-selected > *": {
          color: "#f40000",
        },
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        "&.MuiDrawer-paper": {
          borderColor: "#d8d8d8",
          backgroundColor: "#ffffff",
          opacity: 1,
        },
        "&.MuiCard-root": {
          borderRadius: 25,
        },
      },
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      root: {
        ...inputSelectedStyles.root,
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        ...inputSelectedStyles.root,
      },
    },
  },
  MuiListSubheader: {
    styleOverrides: {
      root: {
        fontWeight: 700,
        color: "#000000",
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        "&.Mui-selected": {
          color: darken("#f40000", 0.5),
        },
      },
    },
  },
  MuiTabs: {
    styleOverrides: {
      root: {
        backgroundColor: "#d8d8d8",
      },
    },
  },
};

export { Styles };
